'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConversations = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConversations = exports.getConversations = (0, _getIn2.default)(['conversations', 'conversationsMap']);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/conversationSelectors/getConversations.js
// module id = 89
// module chunks = 2 3